// extracted by mini-css-extract-plugin
export var blogImg = "ItemBlog-module--blogImg--c012e";
export var heading = "ItemBlog-module--heading--0f1e0";
export var itemBlog = "ItemBlog-module--itemBlog--42447";
export var link = "ItemBlog-module--link--12fa0";
export var text = "ItemBlog-module--text--4d439";
export var titleContainer = "ItemBlog-module--titleContainer--e4963";